export default {
  meta: {
    title: '采购合同'
  }
};
